import { render } from "./minorCall.vue?vue&type=template&id=800d891e&scoped=true"
import script from "./minorCall.vue?vue&type=script&lang=js"
export * from "./minorCall.vue?vue&type=script&lang=js"

import "./minorCall.vue?vue&type=style&index=0&id=800d891e&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800d891e"]])

export default __exports__